var _g, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_162_203",
    "data-name": "Component 162 \\u2013 203",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash",
    transform: "translate(3.141 3.053)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31057",
    "data-name": "Path 31057",
    d: "M18.727,6.55h-.07A66.826,66.826,0,0,0,4.772,6.368L2.979,6.55a.687.687,0,0,1-.141-1.366L4.631,5a68.834,68.834,0,0,1,14.157.182.678.678,0,0,1,.589.747A.661.661,0,0,1,18.727,6.55Z",
    transform: "translate(-2.246 -1.681)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31058",
    "data-name": "Path 31058",
    d: "M8.433,5.32a.56.56,0,0,1-.118-.009.686.686,0,0,1-.555-.783l.2-1.193c.146-.874.346-2.085,2.468-2.085h2.386c2.131,0,2.331,1.257,2.468,2.094l.2,1.184a.679.679,0,1,1-1.338.228l-.2-1.184c-.127-.792-.155-.947-1.12-.947H10.436c-.965,0-.983.127-1.12.938L9.107,4.746A.683.683,0,0,1,8.433,5.32Z",
    transform: "translate(-3.049 -1.25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31059",
    "data-name": "Path 31059",
    d: "M13.8,21.465H8.218c-3.036,0-3.157-1.757-3.253-3.178L4.4,9.118a.679.679,0,0,1,.609-.728.67.67,0,0,1,.7.637L6.27,18.2c.1,1.384.13,1.9,1.948,1.9H13.8c1.827,0,1.861-.519,1.948-1.9l.565-9.169a.655.655,0,1,1,1.3.091l-.565,9.169C16.96,19.708,16.838,21.465,13.8,21.465Z",
    transform: "translate(-2.439 -2.572)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31060",
    "data-name": "Path 31060",
    d: "M13.295,17.116H10.263a.683.683,0,1,1,0-1.366h3.032a.683.683,0,0,1,0,1.366Z",
    transform: "translate(-3.212 -3.042)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31061",
    "data-name": "Path 31061",
    d: "M13.986,13.116H9.433a.683.683,0,0,1,0-1.366h4.553a.683.683,0,0,1,0,1.366Z",
    transform: "translate(-3.138 -2.548)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8646",
    "data-name": "Rectangle 8646",
    width: 24,
    height: 24,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.ac6ee56e13fee6896dab17d63baf5427.svg";
export { ForwardRef as ReactComponent };